var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyTemplate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.71,
    height: 16.71,
    viewBox: "0 0 16.71 16.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-template {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout_1_",
    "data-name": "layout (1)",
    transform: "translate(-0.765 -0.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12687",
    "data-name": "Path 12687",
    className: "cls-template",
    d: "M242.416,152.447v5.281h5.638V147.447h-5.638Z",
    transform: "translate(-230.579 -140.137)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5936",
    "data-name": "Group 5936",
    transform: "translate(0.765 0.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12688",
    "data-name": "Path 12688",
    className: "cls-template",
    d: "M15.673,21.453h16.71V15.79H15.673Z",
    transform: "translate(-15.673 -15.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2785",
    "data-name": "Rectangle 2785",
    className: "cls-template",
    width: 10.307,
    height: 4.898,
    transform: "translate(0 11.812)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2786",
    "data-name": "Rectangle 2786",
    className: "cls-template",
    width: 10.307,
    height: 4.618,
    transform: "translate(0.765 7.31)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyTemplate);
export default __webpack_public_path__ + "static/media/SurveyTemplate.41532a843d784f2371d44ecbbc8bfe48.svg";
export { ForwardRef as ReactComponent };